import styled from 'styled-components';
import { gridSizes } from 'utils/style';
import AppointmentInstructions from './AppointmentInstructions';

export default styled(AppointmentInstructions)`
  margin-bottom: 16px;

  .instructions {
    margin: ${gridSizes('XS')} 0 0 0;
    font-style: italic;
    color: var(--grey700);
    overflow: hidden;
    font-family: Roboto;
  }

  button {
    text-decoration: underline;
    height: 100%;
  }

  .label {
    margin: 0;
    color: var(--grey700);
  }
`;
